<template>
  <div class="dt-left-menu" style=" justify-content: space-between;">
    <div>
    <div class="dt-left-menu-head">
      <div class="dt-left-menu-head-appinfo">
        <div class="dt-left-menu-head-icon">
          <img :src="selectedApp.icon" />
        </div>
      </div>
      <div class="dt-left-menu-head-title">{{ selectedApp.title }}</div>
    </div>
    <div class="dt-left-menu-content">
      <ul>
        <template v-for="item in menus">
          <li
            class="dt-left-menu-li-sub"
            v-if="item.menuShow && !item.leaf"
            @click.stop="openSubMenu(item.id)"
            :key="item.id"
          >
            <i
              :class="[
                'icon',
                'iconfont',
                item.icon == '' ? 'dianzishu' : item.icon,
              ]"
            ></i>
            <span v-if="item.title != ''" class="dt-left-menu-title">{{
              item.title
            }}</span>
            <i class="dt-left-menu-li-arrow" :ref="`subIcon_${item.id}`"></i>
            <ul :ref="`subMenu_${item.id}`" class="dt-left-menu-sub-ul">
              <li
                class="dt-left-menu-sub-li"
                :class="
                  selectedMenuId == subitem.id ? 'dt-left-menu-li-active' : ''
                "
                v-for="subitem in item.children"
                @click.stop="selectEvent(subitem.id)"
                :key="subitem.id"
              >
                <span class="dt-left-menu-title" v-if="subitem.title">
                  {{ subitem.title }}
                </span>
              </li>
            </ul>
          </li>
          <li
            class="dt-left-menu-li"
            :class="selectedMenuId == item.id ? 'dt-left-menu-li-active' : ''"
            @click="selectEvent(item.id)"
            :key="item.id"
            v-else
          >
            <i
              :class="[
                'icon',
                'iconfont',
                item.icon == '' ? 'dianzishu' : item.icon,
              ]"
            ></i>
            <span class="dt-left-menu-title" v-if="item.title != ''">{{
              item.title
            }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
  <!-- 校管显示产品型号说明 -->
    <div style="font-size: 10px;color: rgb(194,194,202);" v-if="adminType == 2">C30课程资源与教学应用系统V2.0</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"; // 引入状态共享
import {
  menu_background,
  menu_color,
  menu_active_color,
} from "@/style/variables.scss.js"; // 导入菜单样式变量
import { replaceParams } from "@/util/menu";
import { valInDeep } from "@/library/js/array.js";
export default {
  name: "leftmenu",
  data() {
    return {
      theme2: "light",
      adminType:this.$store.getters.adminType,
      theme_menu: {
        background: menu_background,
        text: menu_color,
        active_text: menu_active_color,
      }, // 菜单主题
      // openedSubmenuArr: [1]//展开Submenu 的 name 集合
    };
  },
  computed: {
    // 左侧菜单主题
    themeMenu() {
      return this.theme_menu;
    },
    // 左侧菜单默认展开
    menuDefaultOpeneds() {
      let defaultOpenedsArr = [];
      let path = this.$route.path;
      let targetMenu = valInDeep(this.menus, path, "path", "children");
      if (targetMenu.length > 0) {
        defaultOpenedsArr.push(targetMenu[0].parentId);
      }
      return defaultOpenedsArr;
      // return this.menus.map(i => i.id);
    },
    // 导入vuex菜单数据，菜单折叠状态
    ...mapGetters([
      "is_collapse",
      "selectedMenuId",
      "menus",
      "openedSubmenuArr",
      "userId",
      "selectedApp",
    ]),
  },
  watch: {
    $route(to, from) {
      //设置头部面包屑导航
      this.$util.setCurrentPath(this, to.path, to.params);
    },
    selectedApp: "initmenuDefaultOpened",
  },
  methods: {
    /**
     * 默认展开已选菜单
     */
    initmenuDefaultOpened() {
      this.$nextTick(() => {
        let targetMenu = valInDeep(
          this.menus,
          this.selectedMenuId,
          "id",
          "children"
        );
        if (targetMenu.length > 0) {
          if (
            targetMenu[0].parentId != undefined &&
            targetMenu[0].parentId != "0"
          ) {
            this.$nextTick(() => {
              this.openSubMenu(targetMenu[0].parentId, 1);
            });
          }
        }
      });
    },
    /*
     * 选择菜单时触发
     */
    selectEvent(pathKey) {
      //从树形菜单中递归筛选当前路由地址的菜单
      let targetMenu = valInDeep(this.menus, pathKey, "id", "children");
      if (targetMenu.length > 0) {
        //设置当前选择的菜单
        this.$store.dispatch("menu/setSelectedMenuId", pathKey);
        targetMenu[0].path = replaceParams(targetMenu[0].path);

        // 主项目内部打开
        if (targetMenu[0].openMode == 0) {
          //设置头部面包屑导航
          this.$util.setCurrentPath(this, targetMenu[0].path, {});
          // this.$util.routerGo(targetMenu[0].path, targetMenu[0].title);
          this.$router.push({
            path: targetMenu[0].path,
          });
        } else {
          //新窗口打开
          window.open(targetMenu[0].path, "_blank");
        }
      }
    },
    /**
     * 展开或收起二级菜单
     */
    openSubMenu(menuId, isOpen = -1) {
      let currentRef = "subMenu_" + menuId;
      let currentIconRef = "subIcon_" + menuId;
      let curSubMenu = null,
        curSubIcon = null;
      if (this.$refs[currentRef]) {
        curSubMenu = this.$refs[currentRef][0];
      }
      if (this.$refs[currentIconRef]) {
        curSubIcon = this.$refs[currentIconRef][0];
      }

      if (curSubMenu && curSubMenu) {
        if (curSubMenu.className.indexOf("dt-left-menu-sub-open") > -1) {
          curSubMenu.className = "dt-left-menu-sub-ul animated fadeInUp";
          curSubIcon.className = "dt-left-menu-li-arrow rotate-back";
        } else {
          curSubMenu.className =
            "dt-left-menu-sub-ul dt-left-menu-sub-open animated fadeInDown";
          curSubIcon.className = " dt-left-menu-li-arrow rotate";
        }
      }
    },
  },
};
</script>

<style lang="scss">
  @import "../../public/static/menuIconfont/iconfont.css";
.dt-left-menu {
  position: relative;
  min-height: 100%;
  width: 221px;
  background: $main-white;
  border-radius: 10px;
  color: $main-font-normal-color;
  font-size: 14px;
  padding: 26px 30px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  &-head {
    &-appinfo {
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
    }
    &-icon {
      width: 48px;
      height: 48px;
      img {
        width: 100%;
      }
    }
    &-title {
      text-align: center;
    }
  }
  &-content {
    margin-top: 25px;
    padding-top: 11px;
    border-top: 1px solid rgba(239, 239, 239, 1);
    ul {
      li {
        min-height: 50px;
        line-height: 50px;
        margin-bottom: 9px;
        cursor: pointer;
        i {
          font-size: 18px !important;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
    .dt-left-menu-li {
      position: relative;
      padding-left: 30px;
      &:hover {
        background: #fafafa;
        border-radius: 25px 25px 0px 25px;
      }
    }
    .dt-left-menu-li-arrow {
      position: absolute;
      top: 22px;
      right: 0;
      content: "";
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid $main-color;
    }
    .dt-left-menu-li-active {
      background: #2199ff !important;
      border-radius: 25px 25px 0px 25px;
      color: #fff !important;
      font-weight: bold;
      .icon {
        color: #fff;
      }
    }
    .dt-left-menu-sub-ul {
      color: #333;
      display: none;
    }
    .dt-left-menu-li-sub {
      position: relative;
      padding-left: 30px;
    }
    .dt-left-menu-sub-li {
      position: relative;
      padding-left: 40px;
      &:hover {
        background: #fafafa;
        border-radius: 25px 25px 0px 25px;
      }
    }
    .dt-left-menu-sub-open {
      display: block;
    }
  }
}

.dt-left-menu::-webkit-scrollbar {
  display: none !important;
}

.rotate {
  transform-origin: center center;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}

.rotate-back {
  transform-origin: center center;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}
</style>
